import { ShipStatusEnum } from "../../../enums/ship-status-enum";
import { ShipDetailEnum } from "src/app/enums/ship-detail-enum";

export class DeliverySearch {
  initDate: Date;
  endDate: Date;
  vehicle: number;
  status: number;
  client: string;
  shipDetailList: ShipDetailEnum[];

  constructor(initDate: Date, endDate: Date, vehicle: number, status: number, client: string, shipDetailList: ShipDetailEnum[]) {
    this.initDate = initDate;
    this.endDate = endDate;
    this.vehicle = vehicle;
    this.status = status;
    this.client = client;
    this.shipDetailList = shipDetailList;
  }
}
